import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  clearDocumentsSearch,
  clearGlobalSearch,
  clearSearchRecentDocuments,
  registerRecentDocumentsPolling,
  searchDocuments,
  searchGlobally,
  searchRecentDocuments,
  unregisterRecentDocumentsPolling,
} from './search-data.actions';
import {
  ISearchParams,
  RECENT_DOCUMENTS_POLLING_INTERVAL,
} from './search-data.data';

@Injectable()
export class SearchDataDispatcher {
  constructor(private _store: Store<any>) {}

  searchGlobally(query: string, highlights: boolean) {
    const params: ISearchParams = {
      query,
      highlights,
    };

    this._store.dispatch(searchGlobally(params));
  }

  clearGlobalSearch() {
    this._store.dispatch(clearGlobalSearch());
  }

  searchDocuments(query: string, highlights?: boolean) {
    const params: ISearchParams = {
      query,
      page_size: 50,
      highlights: !!highlights,
    };

    this._store.dispatch(searchDocuments(params));
  }

  clearSearchDocuments() {
    this._store.dispatch(clearDocumentsSearch());
  }

  searchRecentDocuments(pageSize: number = 50) {
    const params: ISearchParams = {
      page_size: pageSize,
    };

    this._store.dispatch(searchRecentDocuments(params));
  }

  clearRecentDocuments() {
    this._store.dispatch(clearSearchRecentDocuments());
  }

  registerRecentDocumentsPolling(
    pageSize: number = 5,
    interval: number = RECENT_DOCUMENTS_POLLING_INTERVAL
  ) {
    this._store.dispatch(registerRecentDocumentsPolling(pageSize, interval));
  }

  unregisterRecentDocumentsPolling() {
    this._store.dispatch(unregisterRecentDocumentsPolling());
  }
}
